// @flow
/** @jsx jsx */
import React from 'react';
import universal from '@core-ui/universal';
import { jsx } from '@core-ui/react-stitch';
import {
  CLEAR_FILTER_BUTTON,
  ITEM_COUNT_ARIA_LABEL,
  ITEM_COUNT_TEXT,
  MODELS_TEXT,
  SORT_BY_TEXT,
} from '../localization-tokens';
import { localizeItemCount } from '../collaborators/localize-item-count';
import DrawerTopSection from '../styled/DrawerTopSection';
import DrawerMiddleSection from '../styled/DrawerMiddleSection';
import DashboardSelectContainer from '../styled/DashboardSelectContainer';
// $FlowFixMe
import QuickFilterWrapper from '../../quick-filter-wrapper';

// $FlowFixMe
import { BopisBarFragment } from '../bopis-bar-fragment';

const ClearButton = universal(import('@core-ui/clear-button'), {
  key: 'ClearButton',
});
const FacetBar = universal(import('@cat/facet-bar'), { key: 'default' });
const ItemCount = universal(import('@core-ui/item-count'), {
  key: 'ItemCount',
});
const SizeModelToggle = universal(import('@cat/size-model-toggle'));
const SortBy = universal(import('@cat/sort-by'));
// $FlowFixMe

export const getDashboardExperience = (props: any) => {
  const {
    abbrBrand,
    totalItemCount,
    hasTags,
    mediator,
    publish,
    facetOptions,
    appliedFacets,
    appliedOptions,
    abbrNameForTealium,
    businessUnitId,
    categoryName,
    datalayer,
    pageType,
    selectedNodes,
    webHierarchy,
    localize,
    isModelToggleEnabled,
    isMixedGridEnabled,
    sortByValue,
    sortByOnChange,
    isSortByRatingsEnabled,
    isSwitchContractEnabled,
    isOutOfStockFilterEnabled,
  } = props;

  const itemCountAriaLabel = localizeItemCount(
    localize,
    ITEM_COUNT_ARIA_LABEL,
    totalItemCount
  );

  const itemCountText = localizeItemCount(
    localize,
    ITEM_COUNT_TEXT,
    totalItemCount
  );

  const getOutOfStockFilterFragment = (isOutOfStockFilterEnabled) =>
    isOutOfStockFilterEnabled ? (
      <div position="drawer">{'OUT OF STOCK FILTER ACTIVE'}</div>
    ) : null;

  const quickFilterWrapperParams = {
    facetOptions,
    abbrBrand,
    publish,
    appliedOptions,
    mediator,
    appliedFacets,
  };

  return [
    <DrawerTopSection position="drawer" key="drawer-top-section">
      <ItemCount ariaLabel={itemCountAriaLabel} text={itemCountText} />
      {hasTags && (
        <ClearButton
          localizedButtonText={localize(CLEAR_FILTER_BUTTON)}
          mediator={mediator}
          accessibleFocusSelector="#facet-bar"
        />
      )}
    </DrawerTopSection>,
    <DrawerMiddleSection position="drawer" key="drawer-middle-section">
      <FacetBar
        facets={facetOptions}
        appliedFacets={appliedFacets}
        isSwitchContractEnabled={isSwitchContractEnabled}
      />
    </DrawerMiddleSection>,
    getOutOfStockFilterFragment(isOutOfStockFilterEnabled),
    <BopisBarFragment
      position={'top'}
      key="bopis-bar-dashboard"
      abbrNameForTealium={abbrNameForTealium}
      businessUnitId={businessUnitId}
      categoryName={categoryName}
      datalayer={datalayer}
      mediator={mediator}
      pageType={pageType}
      selectedNodes={selectedNodes}
    />,
    <QuickFilterWrapper
      position="top"
      key="quick-filter-wrapper"
      {...quickFilterWrapperParams}
    />,
    <ItemCount
      position="top"
      ariaLabel={itemCountAriaLabel}
      key="item-count"
      text={itemCountText}
      css={{ marginTop: '1rem' }}
    />,
    isModelToggleEnabled && (
      <DashboardSelectContainer
        position="dashboard"
        title={localize(MODELS_TEXT)}
        key="dashboard-select-container-size-model-toggle"
      >
        <SizeModelToggle
          brand={abbrBrand}
          htmlFor="sizeModelToggleSelect"
          isMobile={true}
          isMixedGridEnabled={isMixedGridEnabled}
          position="dashboard"
          publish={publish}
          title={localize(MODELS_TEXT)}
        />
      </DashboardSelectContainer>
    ),
    <DashboardSelectContainer
      position="dashboard"
      title={localize(SORT_BY_TEXT)}
      key="dashboard-select-container-sort-by"
    >
      <SortBy
        position="dashboard"
        value={sortByValue}
        onChange={sortByOnChange}
        title={localize(SORT_BY_TEXT)}
        htmlFor="sortBySelect"
        hasSeparateLabel
        isSortByRatingsEnabled={isSortByRatingsEnabled}
      />
    </DashboardSelectContainer>,
  ];
};
